// Email validation
export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

// Pakistani phone validation
export const validatePhone = (phone) => {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length === 11 && cleaned.startsWith('0');
};

// Password validation
export const validatePassword = (password) => {
  return password.length >= 6;
};

// Required field validation
export const required = (value) => {
  return value && value.trim().length > 0;
};
